'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGIN_FORM_FIELDS = exports.LOGIN_FORM_NAME = undefined;

var _validationConstants = require('../../../../common/validation/validationConstants');

var LOGIN_FORM_NAME = exports.LOGIN_FORM_NAME = 'login'; // Constants
var LOGIN_FORM_FIELDS = exports.LOGIN_FORM_FIELDS = _validationConstants.LOGIN_FIELDS;


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/login/loginFormConstants.js
// module id = 291
// module chunks = 0